import React, { createContext, useContext, useState, ReactNode } from 'react';

// Define available languages
type Language = 'en' | 'es';

// Define the shape of our context
interface LocaleContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}

// Create the context
const LocaleContext = createContext<LocaleContextType | undefined>(undefined);

// Translation data
const translations = {
  en: () => require('../locales/en/translation.json'),
  es: () => require('../locales/es/translation.json'),
};

// Provider component
interface LocaleProviderProps {
  children: ReactNode;
}

export const LocaleProvider: React.FC<LocaleProviderProps> = ({ children }) => {
  const [language, setLanguage] = useState<Language>('en');

  const t = (key: string): string => {
    const langTranslations = translations[language]();
    return langTranslations[key] || key;
  };

  const value = {
    language,
    setLanguage,
    t
  };

  return (
    <LocaleContext.Provider value={value}>
      {children}
    </LocaleContext.Provider>
  );
};

// Custom hook to use the locale context
export const useLocale = (): LocaleContextType => {
  const context = useContext(LocaleContext);
  if (!context) {
    throw new Error('useLocale must be used within a LocaleProvider');
  }
  return context;
};